import { render, staticRenderFns } from "./TrainingEdit.vue?vue&type=template&id=2998fe86"
import script from "./TrainingEdit.vue?vue&type=script&lang=js"
export * from "./TrainingEdit.vue?vue&type=script&lang=js"
import style0 from "./TrainingEdit.vue?vue&type=style&index=0&id=2998fe86&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports